import styled from "styled-components";
import { InputLabel } from "@material-ui/core";
import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
import { DropdownSelector } from "pages/location/components/add-location/styles";
import { AddUserModal } from "pages/user-profile/components/user-management/styles";
import { SUBTEXT_FONT_SIZE } from "constants/style/font-size";
import { TEXTFIELD_HEADING } from "constants/style/color";

export const WarrantyContainer = styled.div`
  padding: 1.5rem 2rem;
`;

export const TableDiv = styled.div`
  margin-top: 1rem;
`;

export const WarrantySection = styled.div`
  margin-bottom: 2rem;
`;

export const EditFieldsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  margin-bottom: 0.5rem;
`;

export const EditField = styled.div`
  flex: 1;
  min-width: 260px;
`;

export const ReadOnlyValue = styled.p`
  margin: 0.5rem 0 0;
  font-size: 0.9375rem;
  color: ${TEXTFIELD_HEADING};
  font-weight: 500;
`;

export const PdfPreviewContainer = styled.div`
  position: relative;
  width: fit-content;
  max-width: 100%;
`;

export const UnifiedTableContainer = styled.div`
  background: white;
  border-radius: 10px;
  width: 100%;
  height: 70vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const SectionTitleBar = styled.div`
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.color};
  border-left: 3px solid ${({ theme }) => theme.color};
  padding: 0.625rem 1rem;
  font-size: 0.9375rem;
  font-weight: 700;
  flex-shrink: 0;
  margin-top: .24rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SectionTitleText = styled.span``;

export const SectionTitleAction = styled.button`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  border: none;
  background: transparent;
  color: inherit;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0;

  &:hover {
    opacity: 0.85;
  }
`;

export const SectionTitleAddIcon = styled(AddCircleOutlineOutlinedIcon)`
  font-size: 1.25rem;
`;

export const WarrantyHeaderGrid = styled.div`
  flex-shrink: 0;

  > div {
    height: 3.25rem !important;
  }

  .MuiDataGrid-viewport {
    max-height: 0 !important;
    min-height: 0 !important;
  }

  .MuiDataGrid-overlay {
    display: none !important;
  }

  .MuiDataGrid-footerContainer {
    display: none !important;
  }
`;

export const WarrantyDefaultGrid = styled.div`
  flex-shrink: 0;

  > div {
    height: 3.75rem !important;
  }

  .MuiDataGrid-footerContainer {
    display: none !important;
  }
`;

export const WarrantyModelGrid = styled.div`
  flex: 1;
  min-height: 0;

  > div {
    height: 100% !important;
  }
`;

export const TabContent = styled.div`
  padding: 1.5rem 0 0.5rem;
`;

export const FieldContainer = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const InputLabelText = styled(InputLabel)`
  margin-bottom: 0.625rem;
  font-size: ${SUBTEXT_FONT_SIZE} !important;
  color: ${TEXTFIELD_HEADING} !important;
`;

export const ModelDropdown = styled(DropdownSelector)`
  width: 35%;
  min-width: 220px;
`;

export const UploadInput = styled.input`
  display: block;
  margin-top: 0.5rem;
`;

export const PdfPreviewWrapper = styled.div`
  margin-top: 1rem;
  width: fit-content;
  max-width: 100%;
`;

export const PdfPreviewLabel = styled.p`
  margin: 0 0 0.5rem;
  font-size: 0.875rem;
  color: ${TEXTFIELD_HEADING};
  font-weight: 600;
`;

export const PdfPreviewFrame = styled.iframe`
  width: 320px;
  max-width: 100%;
  height: 220px;
  border: 1px solid #d1d2d4;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  pointer-events: none;
`;

export const ClickablePdfPreview = styled.div`
  cursor: pointer;
  width: fit-content;
  max-width: 100%;

  &:focus {
    outline: 2px solid #2d609f;
    outline-offset: 2px;
    border-radius: 8px;
  }
`;

export const UploadSectionsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;

  ${FieldContainer} {
    flex: 1;
    min-width: 280px;
    margin-top: 0;
  }
`;

export const EmptyPreviewText = styled.p`
  margin: 1rem 0 0;
  font-size: 0.875rem;
  color: #666666;
`;

export const PdfExpandModal = styled(AddUserModal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PdfExpandModalBody = styled.div`
  position: relative;
  width: 90vw;
  max-width: 1100px;
  height: 90vh;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.24);
`;

export const PdfExpandCloseButton = styled.button`
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 2;
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.65);
  color: #ffffff;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(0, 0, 0, 0.85);
  }
`;

export const ExpandedPdfFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

export const ActionButtonsRow = styled.div`
  display: flex;
  margin-top: 1.5rem;
  gap: 0.75rem;
`;

export const ExistingPdfsSection = styled.div`
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e0e0e0;
`;

export const SectionHeading = styled.p`
  margin: 0 0 1rem;
  font-size: 0.9375rem;
  color: ${TEXTFIELD_HEADING};
  font-weight: 600;
`;

export const PdfSectionsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
`;
